/**
 * ShopMainPage - Главная страница магазина (legacy)
 */

import React from "react";
import "simplebar-react/dist/simplebar.min.css";
import ShopCategoryButtons from "../../components/shop/ShopCategoryButtons";
import ShopCardsContainer from "../../components/shop/ShopCardsContainer";

const ShopMainPage = () => {
    return (
        <main className="shop-main">
            <h2 className="shop-title">ИГРОВОЙ МАГАЗИН</h2>
            <ShopCategoryButtons />
            <ShopCardsContainer />
        </main>
    );
};

export default ShopMainPage;
